<template>

    <div v-if="form">
        <button type="button" :class="button_class" v-html="button_text" @click.prevent="form.toggleModal()"></button>

        <div class="product-search-selector">
            <transition
                enter-active-class="ease-out duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <!-- Product Search Selector -->
                <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="form.display">
                    <div class="flex items-end justify-center sm:min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div class="fixed inset-0 bg-slate-500 bg-opacity-60 transition-opacity" aria-hidden="true" @click="form.cancelAction()"></div>

                        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div class="inline-block bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all align-top mt-20 w-5/6 md:4/6 xl:w-1/2">
                            <div>
                                <div>
                                    <div class="flex">
                                        <h3 class="flex-1 text-lg leading-6 font-medium text-slate-900" id="modal-title" v-html="title"></h3>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-slate-400 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" @click="form.cancelAction()">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                        </svg>
                                    </div>

                                    <p class="text-sm text-slate-500" v-html="description"></p>

                                    <div class="form-control mt-2">

                                        <form @submit.prevent="">
                                            <input :id="`find-product`" :name="`find-product`" type="text" class="form-input-style relative" placeholder="Find a Product" autocomplete="off" v-model="form.criteria" @blur="form.filterResults()" @keyup="form.filterResults()">
                                        </form>

                                        <div class="absolute left-4 right-4 mb-8 mt-4 border-t-4 border-slate-400 bg-white shadow-xl px-4 py-5 sm:rounded-b-lg z-50 p-10">
                                            <div class="grid grid-cols-2 md:grid-cols-4 max-h-80 overflow-y-scroll" v-if="form.filteredProducts">

                                                <ul class="px-4 py-1" v-for="product in form.filteredProducts">
                                                    <li class="cursor-pointer text-center border-4 p-2 rounded-xl" :class="{
                                                        'border-brand-400': form.isProductSelected(product.sku),
                                                        'border-transparent': !form.isProductSelected(product.sku),
                                                    }" @click.prevent="form.toggleProductSelection(product)">
                                                        <img :src="product.image" class="w-32 h-20 mx-auto rounded shadow-md mb-4" alt="Missing Image" :title="`${product.name} (${product.sku})`">
                                                        <span class="text-sm text-slate-500 font-medium">{{ f.ellipsis(product.name, 20) }}</span><br>
                                                    </li>
                                                </ul>
                                            </div>
                                            <Loading :message="false" v-else></Loading>

                                            <div class="flex mt-4 justify-end border-t-2 border-slate-200 pt-4">
                                                <div class="flex-1">
                                                    <p class="text-xs text-slate-500 pr-4">
                                                        <span class="font-medium">Select/unselect the products that you want to be available as part of this campaign.</span> By default all products available,
                                                        selecting one or more products will change this behaviour to disable all products and only show the selected products.
                                                    </p>
                                                </div>
                                                <button type="submit" class="h-10" @click.prevent="confirmSelection()">Confirm Selection</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- Product Search Selector -->
            </transition>
        </div>
    </div>

</template>

<script>
import {defineComponent} from "vue";
import {ProductSelection} from "../../app/Support/ProductSelection";
import Loading from "@/components/Support/Loading.vue";
import {Formatter} from "../../app/Support/Formatter";

export default defineComponent({
    components: {Loading},
    props: {
        account: {
            type: String,
            required: true,
        },
        currency: {
            required: false,
            default: false
        },
        id: {
            type: String,
            required: false,
            default: 'product-modal',
        },
        title: {
            type: String,
            required: false,
            default: 'Select Products'
        },
        description: {
            type: String,
            required: false,
            default: 'Select or search for a product.',
        },
        button_class: {
            type: String,
            required: false,
            default: '',
        },
        button_text: {
            type: String,
            required: false,
            default: 'Select Products',
        }
    },
    data() {
        return {
            form: new ProductSelection(this.account, this.currency),
            f: new Formatter,
        }
    },
    methods: {
        confirmSelection() {
            this.$emit('confirmSelection', this.form.selectedProducts);

            this.form.confirmAction();
        }
    },
    mounted() {
        this.form.mount();
    }
})
</script>
